import { useParams } from "react-router-dom"
import AdminListView from "./list_view"
import DepartmentTypeObjectTypeAdminListView from "./department_type_object_type/list_view"
import ApprovalRouteAdminListView from "./approval_route_ref/list_view"

/** Кастомные классы для обработок каждой админки регистрируются тут **/

const MODEL_MAP = {
  DepartmentTypeObjectType: DepartmentTypeObjectTypeAdminListView,
  ApprovalRoute: ApprovalRouteAdminListView,
}

export function AdminListViewRouter(props) {
  const { model_name } = useParams()
  const Component = MODEL_MAP[model_name] || AdminListView
  return <Component {...props} />
}